import React, { useState, useEffect, useCallback } from "react";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import {
  subscribe as subscribeAlert,
  getAlertState,
  hideAlert,
} from "../../utils/alertPopupManager";

export const CustomAlert = ({ message, severity = "info" }) => {
  return <Alert severity={severity}>{message}</Alert>;
};

/**
 * Mount once in App.js. Listens to alertPopupManager and shows CustomAlert
 * when showAlert() is called (e.g. from OrbieeFlow).
 */
export function AlertProvider() {
  const [state, setState] = useState(getAlertState());
  const handleClose = useCallback(() => hideAlert(), []);

  useEffect(() => {
    const unsubscribe = subscribeAlert((nextState) => {
      setState(nextState);
    });
    return unsubscribe;
  }, []);

  useEffect(() => {
    if (!state.visible) return;
    const timer = setTimeout(handleClose, 4000);
    return () => clearTimeout(timer);
  }, [state.visible, state.message, handleClose]);

  if (!state.visible) return null;

  return (
    <Snackbar
      open={state.visible}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{ position: "fixed", top: 16, right: 16, zIndex: 9999 }}
    >
      <div>
        <CustomAlert message={state.message} severity={state.severity} />
      </div>
    </Snackbar>
  );
}

export default CustomAlert;
